import { useAppSelector } from "../../../redux/hook";
import IndicatorMetrics from "../IndicatorMetrics";
import PagedIOCsTable from "../PagedIOCsTable";

const IOCLayout = () => {
  const totalCounts = useAppSelector((s: any) => s.sherlock.totalCounts);
  const kpiIndicators = totalCounts?.indicators_count ?? 0;

  return (
    <div className="w-full mr-1">
      <div className="mx-auto px-3 pb-10 backdrop-blur-md border border-white/5 bg-white/5 rounded-lg shadow-sm">
        <div className="grid gap-4 mt-4 grid-cols-1">
          {/* IOC metrics + ranks + chart */}
          <IndicatorMetrics />

          {/* IOC Table */}
          <div className="rounded-lg bg-white shadow-sm border border-gray-200 p-4">
            <div className="flex items-center justify-between mb-2">
              <span className="text-sm font-medium">IOCs</span>
              <span className="text-xs text-gray-600">
                Non-expired IOCs: <strong>{kpiIndicators}</strong>
              </span>
            </div>
            <PagedIOCsTable />
          </div>
        </div>
      </div>
    </div>
  );
};

export default IOCLayout;
